import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import {MatButtonModule} from '@angular/material/button';
import { MatDialogModule} from '@angular/material/dialog';

@Component({
  templateUrl: "./modal.component.html",
  selector: "app-modal",
  standalone: true,
  imports: [MatButtonModule, MatDialogModule],
})
export class ModalComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: { title: string, message: string }) {}
}
